// src/components/EmptyState/EmptyState.jsx
//
// Reusable empty state for "no data" / "not found" / "no results" moments
// throughout the app (empty stage, empty search results, project not found).

import React from "react";
import "./EmptyState.scss";

export default function EmptyState({
  icon = "📭",
  title = "Nothing here yet",
  description = "",
  action = null,
  compact = false,
}) {
  return (
    <div className={`empty-state${compact ? " empty-state--compact" : ""}`}>
      <div className="empty-state__icon" aria-hidden="true">
        {icon}
      </div>
      <h3 className="empty-state__title">{title}</h3>
      {description && <p className="empty-state__description">{description}</p>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}
